import * as React from 'react';

export interface RoomDetailsRoomSummaryInterface {
  roomSummary?: string;
}

export const RoomDetailsRoomSummary: React.FunctionComponent<RoomDetailsRoomSummaryInterface> = ({ roomSummary }) =>
  roomSummary ? <div className="room__size uitk-type-300 pwa-theme--grey-700 all-b-padding-two content">{roomSummary}</div> : null;
